  export const getWindowLocation = () => {
    const { href } = window.location;
    let lastIndex = href.lastIndexOf('/');
    if (lastIndex === -1) {
      lastIndex = href.length;
    }
    return href.substr(0, lastIndex);
  };

export const isValidUrl = (string: string): boolean => {
  try {
    const url = new URL(string);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};
